var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2864 0V48L10.0721 47.9997V39.529H1.715V8.47059H10.0721V0H46.2864ZM17.036 8.47099H37.9288V16.9416H17.036V8.47099ZM37.9288 32.471H17.036V16.9416L8.67886 16.942V32.4713L17.036 32.471V40.9416H37.9288V32.471Z",
    fill: "#06FC99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanto);
export default __webpack_public_path__ + "static/media/canto.689de0c9c561b7ca066080f8531052c8.svg";
export { ForwardRef as ReactComponent };